import type { AssistantChatStreamEvent } from '@scrambl/shared'

export interface CompanionTurnResult {
  status: 'reply' | 'attention' | 'failed' | 'cancelled'
  content: string
}

/** Only a completed stream earns a reply-ready moment. A partial response,
 * pending approval, or failed tool must never look like finished work. */
export function createCompanionTurnTracker() {
  let content = ''
  let completed = false
  let failed = false
  let attention = false
  return {
    observe(event: AssistantChatStreamEvent) {
      if (event.type === 'message_start') content = ''
      if (event.type === 'content_delta') content += event.delta
      // The server can supply its whole final reply here without deltas,
      // including a recovery reply after tools. Prefer this canonical text.
      if (event.type === 'message_end') content = event.content
      if (event.type === 'done') completed = true
      if (event.type === 'error') failed = true
      if (
        event.type === 'confirm_required' ||
        (event.type === 'tool_call_end' && event.status === 'failed')
      )
        attention = true
    },
    result({ aborted = false, threw = false } = {}): CompanionTurnResult {
      return {
        status: aborted
          ? 'cancelled'
          : failed || threw || !completed
            ? 'failed'
            : attention
              ? 'attention'
              : 'reply',
        content,
      }
    },
  }
}
